module.exports = __webpack_public_path__ + "img/invite-member.f22b7b2c.svg";